import { render } from "./anchors.vue?vue&type=template&id=b8e8f2a8"
import script from "./anchors.vue?vue&type=script&lang=js"
export * from "./anchors.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__